var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppraisal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 72,
    viewBox: "0 0 41 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2003 31.6C13.1203 29.24 10.2003 26.8 10.2003 23C10.2003 18.64 14.2403 15.6 21.0003 15.6C28.1203 15.6 30.7603 19 31.0003 24H39.8403C39.5603 17.12 35.3603 10.8 27.0003 8.76V0H15.0003V8.64C7.24027 10.32 1.00027 15.36 1.00027 23.08C1.00027 32.32 8.64027 36.92 19.8003 39.6C29.8003 42 31.8003 45.52 31.8003 49.24C31.8003 52 29.8403 56.4 21.0003 56.4C12.7603 56.4 9.52027 52.72 9.08027 48H0.280273C0.760273 56.76 7.32027 61.68 15.0003 63.32V72H27.0003V63.4C34.8003 61.92 41.0003 57.4 41.0003 49.2C41.0003 37.84 31.2803 33.96 22.2003 31.6Z",
    fill: "#EBDFC8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppraisal);
export default __webpack_public_path__ + "static/media/appraisal.54430d11d1c1fd8b9cd2fcbfef0eff62.svg";
export { ForwardRef as ReactComponent };